const menuButton = document.getElementById('menuButton');

menuButton.addEventListener('click', function() {
  this.classList.toggle('open');
  const menu = document.querySelector('.menu');
  menu.classList.toggle('open');
});